import React from 'react';
import {Link} from 'components';
import {pluralize, useSelector} from 'helpers';
import {session, settings} from 'store';

export const Alert = () => {
  const {gptConnects} = useSelector(settings.settings);
  const {free} = useSelector(session.subscription);
  if (gptConnects > 0) {
    return (
      <span className={gptConnects <= 5 ? 'alert' : ''}>
        You have <b>{gptConnects}</b> ChatGPT {pluralize('request', gptConnects)} left this month.
      </span>
    );
  } else if (free) {
    return (
      <span className="alert">
        You need to <Link className="link" to="/settings/membership/">upgrade</Link> your plan in order to use this feature. <br /><br />
      </span>
    );
  }
  return (
    <span className="alert">
      You have reached the ChatGPT usage limit for this month.
    </span>
  );
};
